/* eslint-disable no-unused-vars */
import { useState, useEffect, Fragment } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
} from "reactstrap";
import { useHistory } from "react-router-dom";
import HandleConfirmAddTeam from "../common/addTeamConfirmation";
import { addTeam, resetTeamData } from "../../reducers/adminReducers";
import Breadcrumb from "../common/breadcrumb";
import { AddTeamValidationSchema } from "../../utils/validation";
const AddTeam = () => {
  const initialState = {
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirmPassword: "",
    steamTradeUrl: "",
    steamId: "",
  };
  const history = useHistory();
  const dispatch = useDispatch();
  const [values, setValues] = useState(initialState);
  const [showPassword, setShowPassword] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [read, setRead] = useState(false);
  const [write, setWrite] = useState(false);
  const [del, setDel] = useState(false);
  const [superAdmin, setSuperAdmin] = useState(false);
  const [superAdminConfirm, setSuperAdminConfirm] = useState(false);
  const [role, setRole] = useState("");
  const [roleManagment, setRoleManagment] = useState(true);
  const [errors, setErrors] = useState("");

  useEffect(() => {
    dispatch(resetTeamData());
  }, [dispatch]);
  const onChangeInput = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
  };

  const showUserPassword = () => {
    setShowPassword(!showPassword);
  };
  let checkEmail = /^[A-Za-z0-9.]{2,}@[A-Za-z0-9]{3,}[.]{1}[A-Za-z]{2,6}$/;
  let checkName = /^[A-Z a-z]{3,}$/;
  let checkPassword =
    /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/;
  const handleOnblur = (e) => {
    const { name, value } = e.target;
    if (value === "") {
      setErrors({ ...errors, [name]: `This field is required` });
    } else if (name === "firstName" && !checkName.test(value)) {
      setErrors({ ...errors, [name]: `Enter only character` });
    } else if (name === "lastName" && !checkName.test(value)) {
      setErrors({ ...errors, [name]: `Enter only character` });
    } else if (name === "email" && !checkEmail.test(value)) {
      setErrors({ ...errors, [name]: `Enter valid email` });
    } else if (name === "password" && !checkPassword.test(value)) {
      setErrors({
        ...errors,
        [name]: `Must contain 8 characters, One uppercase, One lowercase, One number and one special case character`,
      });
    } else if (
      name === "confirmPassword" &&
      values.password !== values.confirmPassword
    ) {
      setErrors({ ...errors, [name]: `Password must be match` });
    } else {
      setErrors({ ...errors, [name]: "" });
    }
  };
  const handleKeyUp = (e) => {
    const { name, value } = e.target;
    if (value !== "") {
      setErrors({ ...errors, [name]: "" });
    }
  };
  let warehouseReadArr = [
    "readCategory",
    "readProduct",
    "readRarityLevel",
    "readBrand",
    "readPartner",
  ];
  let warehouseWriteArr = [
    "writeCategory",
    "writeProduct",
    "writeAddProduct",
    "writeRarityLevel",
    "writeBrand",
    "writePartner",
  ];
  let warehouseDelArr = [
    "delCategory",
    "delProduct",
    "delRarityLevel",
    "delBrand",
    "delPartner",
  ];
  let gameManagementReadArr = ["readBox", "readBotSimulator", "readBattle"];
  let gameManagementWriteArr = ["writeBox", "writeBotSimulator", "writeBattle"];
  let gameManagementDelArr = ["delBox", "delBotSimulator", "delBattle"];
  let profitReadArr = ["readWithdraws", "readOrders", "readDeposits"];
  let profitWriteArr = ["writeWithdraws", "writeOrders", "writeDeposits"];
  let profitDelArr = ["delWithdraws", "delOrders", "delDeposits"];
  let teamManagementReadArr = ["readActivityLog"];
  let teamManagementDelArr = ["delActivityLog"];
  let settingReadArr = ["readProfile", "readPreferences"];
  let settingWriteArr = [
    "writeChangePassword",
    "writeProfile",
    "writePreferences",
  ];
  const handleCheckBox = (e) => {
    let roleArr = [...role];
    if (superAdmin) {
      roleArr.shift();
    }
    setSuperAdmin(false);
    if (e.target.checked) {
      roleArr.push(e.target.name);
      if (e.target.name === "readWarehouse") {
        let existWareRole = roleArr?.some((r) => warehouseReadArr.includes(r));
        if (!existWareRole) {
          let wareRole = [...roleArr, ...warehouseReadArr];
          roleArr = wareRole;
        }
      }
      if (e.target.name === "writeWarehouse") {
        let existWriteWareRole = roleArr?.some((r) =>
          warehouseWriteArr.includes(r)
        );
        if (!existWriteWareRole) {
          let wareWriteRole = [...roleArr, ...warehouseWriteArr];
          roleArr = wareWriteRole;
        }
      }
      if (e.target.name === "delWarehouse") {
        let existDelWareRole = roleArr?.some((r) =>
          warehouseDelArr.includes(r)
        );
        if (!existDelWareRole) {
          let wareDelRole = [...roleArr, ...warehouseDelArr];
          roleArr = wareDelRole;
        }
      }
      //profit push
      if (e.target.name === "readProfitManagement") {
        let existWareRole = roleArr?.some((r) => profitReadArr.includes(r));
        if (!existWareRole) {
          let wareRole = [...roleArr, ...profitReadArr];
          roleArr = wareRole;
        }
      }
      if (e.target.name === "writeProfitManagement") {
        let existWriteWareRole = roleArr?.some((r) =>
          profitWriteArr.includes(r)
        );
        if (!existWriteWareRole) {
          let wareWriteRole = [...roleArr, ...profitWriteArr];
          roleArr = wareWriteRole;
        }
      }
      if (e.target.name === "delProfitManagement") {
        let existDelWareRole = roleArr?.some((r) => profitDelArr.includes(r));
        if (!existDelWareRole) {
          let wareDelRole = [...roleArr, ...profitDelArr];
          roleArr = wareDelRole;
        }
      }

      if (e.target.name === "readGameManagement") {
        let existWareRole = roleArr?.some((r) =>
          gameManagementReadArr.includes(r)
        );
        if (!existWareRole) {
          let wareRole = [...roleArr, ...gameManagementReadArr];
          roleArr = wareRole;
        }
      }
      if (e.target.name === "writeGameManagement") {
        let existWriteWareRole = roleArr?.some((r) =>
          gameManagementWriteArr.includes(r)
        );
        if (!existWriteWareRole) {
          let wareWriteRole = [...roleArr, ...gameManagementWriteArr];
          roleArr = wareWriteRole;
        }
      }
      if (e.target.name === "delGameManagement") {
        let existDelWareRole = roleArr?.some((r) =>
          gameManagementDelArr.includes(r)
        );
        if (!existDelWareRole) {
          let wareDelRole = [...roleArr, ...gameManagementDelArr];
          roleArr = wareDelRole;
        }
      }

      if (e.target.name === "readTeamManagement") {
        let existWareRole = roleArr?.some((r) =>
          teamManagementReadArr.includes(r)
        );
        if (!existWareRole) {
          let wareRole = [...roleArr, ...teamManagementReadArr];
          roleArr = wareRole;
        }
      }
      if (e.target.name === "delTeamManagement") {
        let existDelWareRole = roleArr?.some((r) =>
          teamManagementDelArr.includes(r)
        );
        if (!existDelWareRole) {
          let wareDelRole = [...roleArr, ...teamManagementDelArr];
          roleArr = wareDelRole;
        }
      }

      if (e.target.name === "readSetting") {
        let existReadSetting = roleArr?.some((r) => settingReadArr.includes(r));
        if (!existReadSetting) {
          let wareReadSetRole = [...roleArr, ...settingReadArr];
          roleArr = wareReadSetRole;
        }
      }
      if (e.target.name === "writeSetting") {
        let existReadSetting = roleArr?.some((r) =>
          settingWriteArr.includes(r)
        );
        if (!existReadSetting) {
          let wareWriteSetRole = [...roleArr, ...settingWriteArr];
          roleArr = wareWriteSetRole;
        }
      }
    } else if (roleArr.includes(e.target.name)) {
      if (e.target.name === "readWarehouse") {
        roleArr = roleArr.filter((el) => {
          const res = !warehouseReadArr.includes(el);
          return res;
        });
      }
      if (e.target.name === "writeWarehouse") {
        roleArr = roleArr.filter((el) => {
          const res = !warehouseWriteArr.includes(el);
          return res;
        });
      }
      if (e.target.name === "delWarehouse") {
        roleArr = roleArr.filter((el) => {
          const res = !warehouseDelArr.includes(el);
          return res;
        });
      }

      if (e.target.name === "readGameManagement") {
        roleArr = roleArr.filter((el) => {
          const res = !gameManagementReadArr.includes(el);
          return res;
        });
      }
      if (e.target.name === "writeGameManagement") {
        roleArr = roleArr.filter((el) => {
          const res = !gameManagementWriteArr.includes(el);
          return res;
        });
      }
      if (e.target.name === "delGameManagement") {
        roleArr = roleArr.filter((el) => {
          const res = !gameManagementDelArr.includes(el);
          return res;
        });
      }
      if (e.target.name === "readProfitManagement") {
        roleArr = roleArr.filter((el) => {
          const res = !profitReadArr.includes(el);
          return res;
        });
      }
      if (e.target.name === "writeProfitManagement") {
        roleArr = roleArr.filter((el) => {
          const res = !profitWriteArr.includes(el);
          return res;
        });
      }
      if (e.target.name === "delProfitManagement") {
        roleArr = roleArr.filter((el) => {
          const res = !profitDelArr.includes(el);
          return res;
        });
      }

      if (e.target.name === "readTeamManagement") {
        roleArr = roleArr.filter((el) => {
          const res = !teamManagementReadArr.includes(el);
          return res;
        });
      }
      if (e.target.name === "delTeamManagement") {
        roleArr = roleArr.filter((el) => {
          const res = !teamManagementDelArr.includes(el);
          return res;
        });
      }
      if (e.target.name === "readSetting") {
        roleArr = roleArr.filter((el) => {
          const res = !settingReadArr.includes(el);
          return res;
        });
      }
      if (e.target.name === "writeSetting") {
        roleArr = roleArr.filter((el) => {
          const res = !settingWriteArr.includes(el);
          return res;
        });
      }
      roleArr = roleArr.filter((el) => {
        const res = el !== e.target.name;
        return res;
      });
    }
    setRole(roleArr);
  };

  const handleSuAdCheckBox = (e) => {
    let roleArr = [];
    if (e.target.checked) {
      roleArr.push(e.target.name);
    } else if (roleArr.includes(e.target.name)) {
      roleArr = roleArr.filter((el) => el !== e.target.name);
    }
    setRole(roleArr);
    setSuperAdmin(!superAdmin);
    setSuperAdminConfirm(false);
    setRoleManagment(!roleManagment);
    setRead(false);
    setWrite(false);
    setDel(false);
    if (superAdmin) {
      setRoleManagment(true);
    }
  };

  const handleSuperAdminCheckBox = (e) => {
    setSuperAdminConfirm(!superAdminConfirm);
    if (!superAdmin) {
      setRoleManagment(true);
    }
  };

  const closeConfirmation = () => {
    setSuperAdminConfirm(!superAdminConfirm);
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      const validate = await AddTeamValidationSchema.validate(values, {
        abortEarly: false,
      });
      if (validate) {
        if (role?.length > 0) {
          const res = await dispatch(addTeam({ values, role: role }));
          const { code } = res?.payload;
          if (code === 200) {
            history.push("/team-management");
          }
        } else {
          toast.error("Please Select at least one role for team");
        }
      }
    } catch (error) {
      console.log("Error Is here In add roll -->", error);
      let er = {};
      error.inner.forEach((el) => {
        er[el.path] = el.message;
      });
      setErrors({ ...er });
    }
  };
  return (
    <Fragment>
      <Breadcrumb title="Team Management" parent="Team" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card className="addbox-form">
              <CardHeader>
                <h5> Add Team</h5>
              </CardHeader>
              <CardBody>
                <div className="tab-pane fade show active">
                  <Breadcrumb title="Team" parent="Team Management" />
                  <div className="table-responsive profile-table setting-section sub-admin-section">
                    <Form
                      onSubmit={handleSubmit}
                      className="needs-validation user-add"
                    >
                      <div className="admin-input col-xl-5 col-md-7">
                        <FormGroup>
                          <Label className="col-form-label pt-0">
                            First Name
                          </Label>
                          <Input
                            type="text"
                            placeholder="Enter Name"
                            name="firstName"
                            value={values?.firstName}
                            onChange={onChangeInput}
                            onBlur={handleOnblur}
                            onKeyUp={handleKeyUp}
                          />
                          {errors && errors.firstName && (
                            <span className="text-danger">
                              {errors.firstName}
                            </span>
                          )}
                        </FormGroup>
                        <FormGroup>
                          <Label className="col-form-label pt-0">
                            Last Name
                          </Label>
                          <Input
                            type="text"
                            placeholder="Last Name"
                            name="lastName"
                            value={values?.lastName}
                            onChange={onChangeInput}
                            onBlur={handleOnblur}
                            onKeyUp={handleKeyUp}
                          />
                          {/* {errors && errors.lastName && (
                            <span className='text-danger'>
                              {errors.lastName}
                            </span>
                          )} */}
                        </FormGroup>
                        <FormGroup>
                          <Label className="col-form-label pt-0">Email</Label>
                          <Input
                            type="text"
                            placeholder="Enter email"
                            name="email"
                            autoComplete="off"
                            value={values?.email}
                            onChange={onChangeInput}
                            onBlur={handleOnblur}
                            onKeyUp={handleKeyUp}
                          />
                          {errors && errors.email && (
                            <span className="text-danger">{errors.email}</span>
                          )}
                        </FormGroup>

                        <FormGroup>
                          <Label className="col-form-label pt-0">SteamId</Label>
                          <Input
                            type="text"
                            placeholder="Enter Steam Id "
                            name="steamId"
                            autoComplete="off"
                            value={values?.steamId}
                            onChange={onChangeInput}
                            onBlur={handleOnblur}
                            onKeyUp={handleKeyUp}
                          />
                          {errors && errors.steamId && (
                            <span className="text-danger">
                              {errors.steamId}
                            </span>
                          )}
                        </FormGroup>

                        <FormGroup>
                          <Label className="col-form-label pt-0">
                            Steam Trade Url
                          </Label>
                          <Input
                            type="text"
                            placeholder="Enter trade url "
                            name="steamTradeUrl"
                            autoComplete="off"
                            value={values?.steamTradeUrl}
                            onChange={onChangeInput}
                            onBlur={handleOnblur}
                            onKeyUp={handleKeyUp}
                          />
                          {errors && errors.steamTradeUrl && (
                            <span className="text-danger">
                              {errors.steamTradeUrl}
                            </span>
                          )}
                          <div className="d-flex w-100 justify-content-end mb-2 mt-1  fw-semibold">
                            <a
                              className="text-decoration-underline  bg-light text-dark border  rounded px-2"
                              href="https://steamcommunity.com/id/me/tradeoffers/privacy#trade_offer_access_url"
                              target="_blank"
                              rel="noreferrer"
                            >
                              Where to get
                            </a>
                          </div>
                        </FormGroup>

                        <FormGroup>
                          <Label className="col-form-label pt-0">
                            Password
                          </Label>
                          <Input
                            type={showPassword ? "text" : "password"}
                            placeholder="Enter password"
                            name="password"
                            autoComplete="off"
                            value={values.password}
                            onChange={onChangeInput}
                            onBlur={handleOnblur}
                            onKeyUp={handleKeyUp}
                          />

                          <i
                            className={`fa ${
                              !showPassword ? "fa-eye" : "fa-eye-slash"
                            } `}
                            onClick={showUserPassword}
                          ></i>
                          {errors && errors.password && (
                            <span className="text-danger">
                              {errors.password}
                            </span>
                          )}
                        </FormGroup>

                        <FormGroup>
                          <Label className="col-form-label mt-0 pt-0">
                            Confirm Password
                          </Label>
                          <Input
                            type="password"
                            placeholder="Enter confirm password"
                            name="confirmPassword"
                            value={values.confirmPassword}
                            onChange={onChangeInput}
                            onBlur={handleOnblur}
                            onKeyUp={handleKeyUp}
                          />
                          {errors && errors.confirmPassword && (
                            <span className="text-danger">
                              {errors.confirmPassword}
                            </span>
                          )}
                        </FormGroup>
                      </div>

                      {/* {roleManagment ? (
                        <div className='admin-permission'>
                          <FormGroup check inline>
                            <Label className='d-block track-input track-inp'>
                              <Input
                                type='checkbox'
                                onChange={() => setRead(!read)}
                              />
                              Permission for read
                            </Label>
                          </FormGroup>

                          {read ? (
                            <div className='transactionManage'>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='readDashboard'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('readDashboard')
                                      ? 'checked'
                                      : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Dashboard Management
                                </Label>
                              </FormGroup>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='readWarehouse'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('readWarehouse')
                                      ? 'checked'
                                      : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Warehouse Management
                                </Label>
                              </FormGroup>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='readCategory'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('readCategory')
                                      ? 'checked'
                                      : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Category Management
                                </Label>
                              </FormGroup>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='readProduct'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('readProduct')
                                      ? 'checked'
                                      : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Product Management
                                </Label>
                              </FormGroup>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='readRarityLevel'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('readRarityLevel')
                                      ? 'checked'
                                      : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Rarity Level Management
                                </Label>
                              </FormGroup>

                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='readBrand'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('readBrand') ? 'checked' : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Brand Management
                                </Label>
                              </FormGroup>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='readPartner'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('readPartner')
                                      ? 'checked'
                                      : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Partner Management
                                </Label>
                              </FormGroup>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='readGameManagement'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('readGameManagement')
                                      ? 'checked'
                                      : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Game Management
                                </Label>
                              </FormGroup>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='readBox'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('readBox') ? 'checked' : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Box Management
                                </Label>
                              </FormGroup>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='readBotSimulator'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('readBotSimulator')
                                      ? 'checked'
                                      : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Bot Simulator Management
                                </Label>
                              </FormGroup>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='readBattle'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('readBattle')
                                      ? 'checked'
                                      : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Battle Management
                                </Label>
                              </FormGroup>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='readUsers'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('readUsers') ? 'checked' : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Users Management
                                </Label>
                              </FormGroup>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='readFunds'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('readFunds') ? 'checked' : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Funds Management
                                </Label>
                              </FormGroup>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='readProfitManagement'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('readProfitManagement')
                                      ? 'checked'
                                      : ''
                                  }
                                />

                                <Label className='col-form-label pt-0' check>
                                  Profit Management
                                </Label>
                              </FormGroup>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='readWithdraws'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('readWithdraws')
                                      ? 'checked'
                                      : ''
                                  }
                                />

                                <Label className='col-form-label pt-0' check>
                                  Withdraws
                                </Label>
                              </FormGroup>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='readOrders'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('readOrders')
                                      ? 'checked'
                                      : ''
                                  }
                                />

                                <Label className='col-form-label pt-0' check>
                                  Orders Management
                                </Label>
                              </FormGroup>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='readDeposits'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('readDeposits')
                                      ? 'checked'
                                      : ''
                                  }
                                />

                                <Label className='col-form-label pt-0' check>
                                  Deposits
                                </Label>
                              </FormGroup>

                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='readSetting'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('readSetting')
                                      ? 'checked'
                                      : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Setting Management
                                </Label>
                              </FormGroup>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='readProfile'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('readProfile')
                                      ? 'checked'
                                      : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Profile Management
                                </Label>
                              </FormGroup>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='readPreferences'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('readPreferences')
                                      ? 'checked'
                                      : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Preferences
                                </Label>
                              </FormGroup>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='readTeamManagement'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('readTeamManagement')
                                      ? 'checked'
                                      : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Team Management
                                </Label>
                              </FormGroup>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='readActivityLog'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('readActivityLog')
                                      ? 'checked'
                                      : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Activity Logs Management
                                </Label>
                              </FormGroup>
                            </div>
                          ) : (
                            ''
                          )}
                        </div>
                      ) : (
                        ''
                      )}
                      {roleManagment ? (
                        <div className='admin-permission'>
                          <FormGroup check inline>
                            <Label className='d-block track-input track-inp'>
                              <Input
                                type='checkbox'
                                onChange={() => setWrite(!write)}
                              />
                              Permission for write
                            </Label>
                          </FormGroup>

                          {write ? (
                            <div className='transactionManage'>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='writeWarehouse'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('writeWarehouse')
                                      ? 'checked'
                                      : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Warehouse Management
                                </Label>
                              </FormGroup>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='writeCategory'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('writeCategory')
                                      ? 'checked'
                                      : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Category Management
                                </Label>
                              </FormGroup>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='writeProduct'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('writeProduct')
                                      ? 'checked'
                                      : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Product Management
                                </Label>
                              </FormGroup>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='writeAddProduct'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('writeAddProduct')
                                      ? 'checked'
                                      : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Add Product Management
                                </Label>
                              </FormGroup>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='writeRarityLevel'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('writeRarityLevel')
                                      ? 'checked'
                                      : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Rarity Level Management
                                </Label>
                              </FormGroup>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='writeBrand'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('writeBrand')
                                      ? 'checked'
                                      : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Brand Management
                                </Label>
                              </FormGroup>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='writePartner'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('writePartner')
                                      ? 'checked'
                                      : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Partner Management
                                </Label>
                              </FormGroup>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='writeGameManagement'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('writeGameManagement')
                                      ? 'checked'
                                      : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Game Management
                                </Label>
                              </FormGroup>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='writeBox'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('writeBox') ? 'checked' : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Box Management
                                </Label>
                              </FormGroup>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='writeBotSimulator'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('writeBotSimulator')
                                      ? 'checked'
                                      : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Bot Simulator Management
                                </Label>
                              </FormGroup>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='writeBattle'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('writeBattle')
                                      ? 'checked'
                                      : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Battle Management
                                </Label>
                              </FormGroup>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='writeUsers'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('writeUsers')
                                      ? 'checked'
                                      : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Users Management
                                </Label>
                              </FormGroup>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='writeFunds'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('writeFunds')
                                      ? 'checked'
                                      : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Funds Management
                                </Label>
                              </FormGroup>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='writeProfitManagement'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('writeProfitManagement')
                                      ? 'checked'
                                      : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Profit Management
                                </Label>
                              </FormGroup>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='writeWithdraws'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('writeWithdraws')
                                      ? 'checked'
                                      : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Withdraws
                                </Label>
                              </FormGroup>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='writeOrders'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('writeOrders')
                                      ? 'checked'
                                      : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Orders Management
                                </Label>
                              </FormGroup>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='writeDeposits'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('writeDeposits')
                                      ? 'checked'
                                      : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Deposits
                                </Label>
                              </FormGroup>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='writeSetting'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('writeSetting')
                                      ? 'checked'
                                      : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Setting Management
                                </Label>
                              </FormGroup>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='writeProfile'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('writeProfile')
                                      ? 'checked'
                                      : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Profile Management
                                </Label>
                              </FormGroup>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='writeChangePassword'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('writeChangePassword')
                                      ? 'checked'
                                      : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Password Management
                                </Label>
                              </FormGroup>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='writePreferences'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('writePreferences')
                                      ? 'checked'
                                      : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Preferences
                                </Label>
                              </FormGroup>
                            </div>
                          ) : (
                            ''
                          )}
                        </div>
                      ) : (
                        ''
                      )}
                      {roleManagment ? (
                        <div className='admin-permission'>
                          <FormGroup check inline>
                            <Label className='d-block track-input track-inp'>
                              <Input
                                type='checkbox'
                                onChange={() => setDel(!del)}
                              />
                              Permission for delete
                            </Label>
                          </FormGroup>

                          {del ? (
                            <div className='transactionManage'>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='delWarehouse'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('delWarehouse')
                                      ? 'checked'
                                      : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Warehouse Management
                                </Label>
                              </FormGroup>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='delCategory'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('delCategory')
                                      ? 'checked'
                                      : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Category Management
                                </Label>
                              </FormGroup>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='delProduct'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('delProduct')
                                      ? 'checked'
                                      : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Product Management
                                </Label>
                              </FormGroup>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='delRarityLevel'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('delRarityLevel')
                                      ? 'checked'
                                      : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Rarity Level Management
                                </Label>
                              </FormGroup>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='delBrand'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('delBrand') ? 'checked' : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Brand Management
                                </Label>
                              </FormGroup>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='delPartner'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('delPartner')
                                      ? 'checked'
                                      : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Partner Management
                                </Label>
                              </FormGroup>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='delBox'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('delBox') ? 'checked' : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Box Management
                                </Label>
                              </FormGroup>

                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='delGameManagement'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('delGameManagement')
                                      ? 'checked'
                                      : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Game Management
                                </Label>
                              </FormGroup>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='delBotSimulator'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('delBotSimulator')
                                      ? 'checked'
                                      : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Bot Simulator Management
                                </Label>
                              </FormGroup>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='delBattle'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('delBattle') ? 'checked' : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Battle Management
                                </Label>
                              </FormGroup>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='delUsers'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('delUsers') ? 'checked' : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Users Management
                                </Label>
                              </FormGroup>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='delFunds'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('delFunds') ? 'checked' : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Funds Management
                                </Label>
                              </FormGroup>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='delProfitManagement'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('delProfitManagement')
                                      ? 'checked'
                                      : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Profit Management
                                </Label>
                              </FormGroup>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='delWithdraws'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('delWithdraws')
                                      ? 'checked'
                                      : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Withdraws
                                </Label>
                              </FormGroup>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='delOrders'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('delOrders') ? 'checked' : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Orders Management
                                </Label>
                              </FormGroup>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='delDeposits'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('delDeposits')
                                      ? 'checked'
                                      : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Deposits
                                </Label>
                              </FormGroup>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='delPreferences'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('delPreferences')
                                      ? 'checked'
                                      : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Preferences
                                </Label>
                              </FormGroup>

                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='delTeamManagement'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('delTeamManagement')
                                      ? 'checked'
                                      : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Team Management
                                </Label>
                              </FormGroup>
                              <FormGroup check inline>
                                <Input
                                  type='checkbox'
                                  name='delActivityLog'
                                  onChange={handleCheckBox}
                                  checked={
                                    role?.includes('delActivityLog')
                                      ? 'checked'
                                      : ''
                                  }
                                />
                                <Label className='col-form-label pt-0' check>
                                  Activity Logs Management
                                </Label>
                              </FormGroup>
                            </div>
                          ) : (
                            ''
                          )}
                        </div>
                      ) : (
                        ''
                      )} */}
                      <div className="admin-permission">
                        <FormGroup check inline>
                          <Label className="d-block track-input track-inp">
                            <Input
                              type="checkbox"
                              name="suUsers"
                              checked={superAdmin ? "checked" : ""}
                              onClick={handleSuperAdminCheckBox}
                              onChange={(e) =>
                                superAdmin ? handleSuAdCheckBox(e) : ""
                              }
                            />
                            Permission for super admin
                          </Label>
                        </FormGroup>
                        <HandleConfirmAddTeam
                          open={superAdminConfirm}
                          onCloseModal={closeConfirmation}
                          handleConfirm={handleSuAdCheckBox}
                        />
                      </div>

                      <div className="form-button">
                        <Button
                          color="primary"
                          style={{ borderRadius: "25px" }}
                          type="submit"
                          className="main-btn"
                        >
                          Submit
                        </Button>
                      </div>
                    </Form>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};
export default AddTeam;
